import { createRoot } from "react-dom/client";
import React from 'react';
import App from "./App.tsx";
import "./index.css";
import { HelmetProvider } from 'react-helmet-async';
localStorage.setItem('kaynin_soft_launch_enabled', 'false');
// Clear any persisted CMS layout to fallback to defaults
Object.keys(localStorage).forEach(key => {
  if (key.startsWith('kaynin_cms_layout_')) {
    localStorage.removeItem(key);
  }
});
console.log("Main.tsx is executing");



class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("Global Error Caught:", error, info); }
  render() { 
    if (this.state.hasError) return <div style={{color:'red'}}>Erreur Critique: {this.state.error?.toString()}</div>;
    return this.props.children; 
  }
}

const root = document.getElementById("root");
console.log("Root element:", root);
createRoot(root!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

console.log('Kaynin V3.1 Prod Update - Cache Buster');
